import React, { useState } from 'react';
import StarRating from '../StarRating/StarRating';

function NpsStarRating({ question, setStarRatingData, eveId, disabled}) {
  const [selectedRating, setSelectedRating] = useState(null);

  const ratingChanged = (response) => {
    setSelectedRating(response);
    const newData = {
      questionId: question?.questionId,
      answer: response,
      eventId: eveId,
    };
    setStarRatingData(newData);
  };

  return (
    <>
      <div className="npsQuestion">{question?.questionTitle}</div>
      <StarRating
        customClass={disabled ? 'npsStar disabled' : 'npsStar'}
        rating={selectedRating}
        handleChange={(value) => {
          ratingChanged(value);
        }}
        starBorderYellow
      />
    </>
  );
}

export default NpsStarRating;
